<template>
  <div class="HintsTemplate animated fadeIn">
    <label class="HintsTemplate__important">Wybrana opcja:</label>
    Zadzwoń od razu do użytkownika a następnie do wszystkich konsultantów w wybranym Wirtualnym Oddziale.
    <ol class="HintsTemplate__description HintsTemplate__list">
      <li>
        Użytkownik podczas połączenia usłyszy krótką zapowiedź głosową,
        po czym system call web zadzwoni do wszystkich konsultantów w wybranym przez niego Wirtualnym Oddziale.
      </li>
      <li>
        Konsultant, który odbierze połączenie, usłyszy informację,
        że połączenie następuje z systemu call web i poprosi o potwierdzenie przyjęcia połączenia.
      </li>
      <li>Po poprawnym potwierdzeniu, nastąpi zestawienie połączenia pomiędzy Konsultantem a użytkownikiem strony internetowej.</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'VirtualDepartmentInhoursBehavior',
};
</script>

<style lang="sass" scoped>

</style>
